/* eslint-disable */
import React, { useMemo } from 'react';
import moment from 'moment';

import { useGetTableLayout } from '../../hooks';
import { useTranslate } from '../../../../../../../../hooks';

import {
  AllRowsSelectedType,
  CurrentEmployeeShiftListType,
  CustomBodyRenderType,
} from '../../types';
import { Day } from '../../../types';

import './CurrentEmployeeShiftList.css';

import DefaultTableBodyCell from '../../../../../../../../components/table/DefaultTableBodyCell';
import { Table } from '../../../../../../../../components';
import { EmpNameCard, ShiftTImeColumn, DateColumn } from '../common';

export function CurrentEmployeeShiftList({
  data,
  handleSelectShift,
  selectedShifts,
  days,
}: CurrentEmployeeShiftListType) {
  const { translate } = useTranslate();
  const { layout } = useGetTableLayout({ type: 1 });

  //table columns config
  const columns = useMemo(
    () => [
      {
        name: 'date',
        label: translate('Date'),
        options: {
          customBodyRender: (value: CustomBodyRenderType) => {
            return <DateColumn value={value} />;
          },
        },
      },
      {
        name: 'shiftTime',
        label: translate('Time'),
        options: {
          customBodyRender: (value: CustomBodyRenderType) => {
            return <ShiftTImeColumn value={value} />;
          },
        },
      },
      {
        name: 'code',
        label: translate('Shift Code'),
        options: {
          customBodyRender: (value: CustomBodyRenderType) => {
            return (
              <DefaultTableBodyCell
                value={value?.code}
                className={`current-emp-shift-code-cell ${
                  value?.isToday && 'font-success'
                }`}
              />
            );
          },
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const tableData = useMemo(() => {
    const res = data?.shifts?.map((item: Day) => {
      return {
        date: { date: item?.date, isToday: moment().isSame(item?.date, 'day') },
        shiftTime: {
          startTime: item?.startTime,
          endTime: item?.endTime,
          isFlexi: item?.isFlexi,
          isHoliday: item?.isHoliday,
          isOvernight: item?.isOvernight,
          isWeekOff: item?.isWeekOff,
          onLeave: item?.isLeave,
          code: item?.code,
        },
        code: { code: item?.code, isToday: moment().isSame(item?.date, 'day') },
      };
    });

    return res;
  }, [data]);

  const handleSelect = (_: any[], allRowsSelected: any[]) => {
    interface MyObject {
      [key: string | number]: Day;
    }

    const newAllSelected: MyObject = {};

    allRowsSelected?.forEach((row: AllRowsSelectedType) => {
      newAllSelected[row?.dataIndex] = tableData[row?.dataIndex];
    });
    if (handleSelectShift) {
      handleSelectShift({
        shifts: newAllSelected,
      });
    }
  };

  return (
    <div className="current-emp-shift">
      <p className="current-emp-shift-title">{translate('Shifts')}</p>
      <EmpNameCard
        empName={data?.employeeName}
        designation={data?.employeeDepartmentName}
        profilePic={data?.employeeProfileImage}
        containerClassName="current-emp-shift-name-card-container"
      />
      <div className="shift-swap">
        <Table
          columns={columns}
          data={tableData || []}
          count={days}
          options={{
            pagination: false,
            selectableRows: 'multiple',
            selectableRowsHeader: true,
            ...layout,
            selectToolbarPlacement: 'none',
            rowsSelected: selectedShifts,
            onRowSelectionChange: handleSelect,
          }}
        />
      </div>
    </div>
  );
}
